
    <!--
 * 竖版-页面导航
 * @LastEditTime: Tue Dec 17 2024 15:43:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_92PM131"  v-show="compData.isShow" :class="[`normal`,`u_c_92PM131`]" ><div id="u_c_3IUT132"  v-for="(btnItem, btnI) in compData.btnList" :key="btnI" v-show="btnI != 2 || btnI == 2 && !compData.hidePay" :class="[`normal`,`u_c_3IUT132`]" ><a id="u_c_1PZ0133" href="javascript:;" :style="`${ btnItem.pic ? `background-image:url(${ btnItem.pic })` : '' }`" :class="[`${ btnItem.cur ? 'cur' : '' }`,`normal btn-light`,`u_c_1PZ0133`]" @click="u_c_1PZ0133_event_F9W931($event,btnI,btnItem.block,btnItem.link)"><div id="u_c_FXUU134"  v-html="pageData.isEdit ? btnItem.text : getBtnText(btnItem)" :class="[`normal`,`u_c_FXUU134`]" ></div></a></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"每日\n首充"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"签到\n获豪礼"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"前往\n充值"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"幸运\n抽奖"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"奖励\n送不停"}],"isShow":true,"hidePay":false},"zh-CN":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"首储赠礼"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"签到好礼"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"前往储值"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"庆典豪华礼盒"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"二重好礼"}],"isShow":true,"hidePay":false},"zh-TW":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"首儲贈禮"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"簽到好禮"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"前往儲值"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"慶典豪華禮盒"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"二重好禮"}],"isShow":true,"hidePay":false},"en-US":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"1st Top-up Gift"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Sign-in Gift"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Top Up"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Deluxe Anniversary Box"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Bonus Gift"}],"isShow":true,"hidePay":false},"ja-JP":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"初回チャージ ボーナス"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"サインイン\nボーナス"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"チャージへ"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"豪華記念ギフト"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"豪華ボーナス"}],"isShow":true,"hidePay":false},"ko-KR":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"첫 충전 \n혜택"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"출석\n선물"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"충전하기"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"축제 호화 선물함"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"더블 보너스"}],"isShow":true,"hidePay":false},"th-TH":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"เติมครั้งแรกมีรางวัล"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"รางวัลเช็คอิน"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"ไปเติมเงิน"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"กล่องสุดหรูงานฉลอง"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"รางวัล 2 ชั้น"}],"isShow":true,"hidePay":false},"vi-VN":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Tặng quà nạp đầu"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Quà điểm danh"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Tới Nạp"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":""},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Quà Thêm"}],"isShow":true,"hidePay":false},"de-DE":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"1. Auflade-Geschenk"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Anmeldegeschenk"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Aufladen"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Deluxe Jubiläumskiste"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Bonus-Geschenk"}],"isShow":true,"hidePay":false},"fr-FR":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Cadeau de 1ère de Recharge"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Cadeau de Connexion"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Recharge"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Boîte Anniversaire Deluxe"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Cadeau Bonus"}],"isShow":true,"hidePay":false},"ru-RU":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Подарок за 1-е Пополнение"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Подарок за Вход"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Пополнение"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Шикарный юбилейный ящик"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Бонусный Подарок"}],"isShow":true,"hidePay":false},"es-ES":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Regalo de la 1.ª recarga"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Regalo de registro"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Recargar"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Caja de aniversario lujosas"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Regalo de bonificación"}],"isShow":true,"hidePay":false},"pt-PT":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"1º presente de recarga"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Presente de login"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Recarregar"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Caixa de Aniversário Deluxe"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Presente Bônus"}],"isShow":true,"hidePay":false},"it-IT":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"1mo Regalo Ricarica"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Regalo Iscrizione"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Ricarica"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Scatola Anniversario Deluxe\n"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Regalo Bonus"}],"isShow":true,"hidePay":false},"tr-TR":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"1. Yükleme Hediyesi"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Giriş Hediyesi"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Yükleme"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Caixa de Aniversário Deluxe"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Bonus Hediye"}],"isShow":true,"hidePay":false},"pl-PL":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Prezent 1wszego doładowania"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Prezent logowania"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Doładowanie"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Luksusowe Pudełko Rocznicowe\n"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Prezent bonusu"}],"isShow":true,"hidePay":false},"id-ID":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Hadiah Top Up Perdana"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Hadiah Sign-In"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Pergi Top up"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Celebration Luxury Box\n"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"Bonus Hadiah"}],"isShow":true,"hidePay":false},"ar-SA":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"هدية الشحن الأول"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"هدية تسجيل الحضور"},{"pic":"","block":"pay","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"التوجه للشحن"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"هدية الاحتفال الفاخرة\n"},{"pic":"","block":"u_c_O87P194","link":"https://pay.pnsofficial.com/platform/officialStore.html?gameId=191","text":"هدايا مضاعفة"}],"isShow":true,"hidePay":false}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '页面导航';

    // 自定义setup - 开始
    const getCurLink = inject("getCurLink", (link) => {})

const init = () => {
  compData.isShow = true;
  if (bridge.runInsdk()) {
    compData.btnList = compData.btnList.filter((item) => {
      return item.block != "pay";
    });
  }
  compData.btnList.forEach((item) => {
    if (item.link) {
      item.link = utils.getStoreLinkWithCidScid({
        link: item.link,
        paramsObj: {
          language: curLang,
          gameId: pageData.gameId,
        },
        pageId: pageData.pageId,
      })
    }
  })
}

init()
// 获取按钮名称
const getBtnText = (item) => {
  if (item.block === "pay") {
    return getLangTxt("goPay");
  }
  if (item.block === "download") {
    return getLangTxt("downloadGame");
  }
  return item.text;
};
let sectionPosition = []
onMounted(() => {
  let curScroll = document.documentElement.scrollTop
  compData.btnList.forEach((item, index) => {
    if (item.block && !["pay", "download"].includes(item.block)) {
      let _ele = document.getElementById(item.block)
      if (_ele) {
        let _p = _ele.getBoundingClientRect()
        sectionPosition.push({
          top: Math.floor(_p.top + curScroll + _p.height / 3),
          realTop: Math.floor(_p.top + curScroll),
          index,
        })
      }
    }
  })
  const throttledFn = vueUse.useThrottleFn(() => {
    let curScroll = document.documentElement.scrollTop
    let curIndex = sectionPosition.findIndex((item) => item.top > curScroll)
    if (~curIndex) {
      compData.btnList.forEach((item, index) => {
        if (index == sectionPosition[curIndex].index) {
          item.cur = 1
        } else {
          item.cur = 0
        }
      })
    }
  })
  window.addEventListener("scroll", throttledFn)
  throttledFn()
})

if (utils.getUrlParams("scid") == 'menu') {
  compData.hidePay = true;
};
      // 自定义元素1PZ0133的click事件
      const u_c_1PZ0133_event_F9W931= async (e,index,block,link)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `导航栏-${index}`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
})

if (!block || ["pay", "download"].includes(block)) {
  bridge.open(link)
} else {
  let curTopIndex = sectionPosition.findIndex(
    (item) => item.index == index
  )
  if (~curTopIndex) {
    window.scrollTo({
      top: sectionPosition[curTopIndex].realTop,
      behavior: "smooth",
    })
  }
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.default{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.default{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.default{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.zh-CN{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.zh-CN{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.zh-CN{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.zh-CN{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.zh-TW{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.zh-TW{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.zh-TW{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.zh-TW{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.en-US{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.en-US{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.en-US{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.en-US{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.ja-JP{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.ja-JP{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.ja-JP{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.ja-JP{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.ko-KR{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.ko-KR{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.ko-KR{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.ko-KR{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.th-TH{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.th-TH{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.th-TH{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.th-TH{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.vi-VN{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.vi-VN{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.vi-VN{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.vi-VN{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.de-DE{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.de-DE{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.de-DE{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.de-DE{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.fr-FR{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.fr-FR{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.fr-FR{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.fr-FR{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.ru-RU{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.ru-RU{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.ru-RU{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.ru-RU{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.es-ES{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.es-ES{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.es-ES{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.es-ES{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.pt-PT{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.pt-PT{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.pt-PT{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.pt-PT{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.it-IT{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.it-IT{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.it-IT{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.it-IT{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.tr-TR{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.tr-TR{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.tr-TR{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.tr-TR{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.pl-PL{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.pl-PL{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.pl-PL{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.pl-PL{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.id-ID{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.id-ID{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.id-ID{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.id-ID{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.ar-SA{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.ar-SA{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.ar-SA{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264689-81.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.ar-SA{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}
</style>
